import { Component, OnInit, Input } from '@angular/core';
import { TableHandler } from '../../../../../../../classes';
import { FormGroup, Validators, FormControl } from '@angular/forms';

@Component({
  selector: '[range-dropdown-x]',
  templateUrl: './range-dropdown-x.component.html',
  styleUrls: ['./range-dropdown-x.component.scss']
})
export class RangeDropdownXComponent implements OnInit {
  @Input() table:TableHandler;
  @Input() tableFormGroup:FormGroup;
  min:number = 1;
  max:number = 10;
  constructor() { }

  xLength:FormControl;
  ngOnInit() {
    this.xLength = new FormControl(this.table.xLength, [Validators.min(this.min), Validators.max(this.max)]);
    if (this.tableFormGroup) this.tableFormGroup.setControl('xLength', this.xLength);
  }
  setXLength (v:number) {
    this.table.xLength = v;
    this.xLength.setValue(v);
  }

}
